import {
  CREATE_MIXTUREORDER_REQUEST,
  CREATE_MIXTUREORDER_ERROR,
  CREATE_MIXTUREORDER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/createEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.CREATE_ENTITY_REQUEST = CREATE_MIXTUREORDER_REQUEST;
  context.CREATE_ENTITY_ERROR = CREATE_MIXTUREORDER_ERROR;
  context.CREATE_ENTITY_SUCCESS = CREATE_MIXTUREORDER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixtureOrder";
  context.entityLocation = RESOURCES.MixtureOrders;
  context.hasOrganisation = true;

  return context.execute(context)(entity)(state, action);
};